import { createSlice } from '@reduxjs/toolkit';
import { fetchGroupData } from '../CommunityAPI/communityApi';

const fetchGroupDataSlice = createSlice({
    name: 'fetchGroupData',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handle fetchGroupData cases
            .addCase(fetchGroupData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchGroupData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchGroupData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    },
});

export default fetchGroupDataSlice.reducer;
